import moment from "moment";

export function parsearLineasGenerico(allLines) {
  const PRODUCT_LINE =
    /^(\d{1,3})\s+(\d+(?:\.\d+)?)\s+[A-Z0-9]{2,5}\s+\d{8}\s+[A-Z]{1,5}\d+\s+(.+)$/i;

  const PRICE_SUFFIX =
    /\s+\$\s*[\d,]+\.\d+(?:\s+\$\s*[\d,]+\.\d+)*\s*$/;

  // Busca lotes aunque estén dentro de la misma línea del producto
  const LOT_REGEX =
    /Cant:\s*(\d+)\s*-\s*Lote:\s*([^\s-]+)\s*-\s*Cad:\s*([0-9]{2}\/[0-9]{2}\/[0-9]{4}|-)/gi;

  const productsByDesc = new Map();
  let currentEntry = null;

  const agregarLote = (entry, cantidad, numero, cadRaw) => {
    if (!entry || !numero) return;

    let caducidad = null;

    if (cadRaw && cadRaw.trim() !== "-") {
      caducidad = moment(cadRaw.trim(), "DD/MM/YYYY", true);
      if (!caducidad.isValid()) caducidad = null;
    }

    const existente = entry.lotes.find(
      l => String(l.numero).toUpperCase() === String(numero).toUpperCase()
    );

    if (existente) {
      existente.cantidad = (Number(existente.cantidad) || 0) + cantidad;
    } else {
      entry.lotes.push({
        numero: numero.trim(),
        caducidad,
        cantidad
      });
    }
  };

  for (const rawLine of allLines) {
    if (!rawLine) continue;

    let line = rawLine.replace(/\s+/g, " ").trim();
    if (!line) continue;

    const pm = line.match(PRODUCT_LINE);

    if (pm) {
      const cantidadLinea = parseInt(pm[2], 10);

      // Quitar precios y lotes de la descripción
      let desc = pm[3]
        .replace(PRICE_SUFFIX, "")
        .replace(LOT_REGEX, "")
        .trim();

      const key = desc.toLowerCase();

      if (!productsByDesc.has(key)) {
        currentEntry = {
          lotes: [],
          cantidadLinea
        };

        productsByDesc.set(key, currentEntry);
      } else {
        currentEntry = productsByDesc.get(key);
        currentEntry.cantidadLinea =
          (Number(currentEntry.cantidadLinea) || 0) + cantidadLinea;
      }

      // Si el lote venía en la misma línea del producto
      LOT_REGEX.lastIndex = 0;
      let lm;
      while ((lm = LOT_REGEX.exec(line)) !== null) {
        agregarLote(
          currentEntry,
          parseInt(lm[1], 10),
          lm[2],
          lm[3]
        );
      }

      continue;
    }

    // Si es línea separada de lote
    if (currentEntry) {
      LOT_REGEX.lastIndex = 0;
      let lm;
      while ((lm = LOT_REGEX.exec(line)) !== null) {
        agregarLote(
          currentEntry,
          parseInt(lm[1], 10),
          lm[2],
          lm[3]
        );
      }
    }
  }

  return productsByDesc;
}